import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { AdminUserTenants } from '../api/queries/admin-user-queries';
import { AdminUser } from '../api/types/GraphQL';
import { AdminUserPreferenceResponse } from '../api/types/admin-user-preference';
import { environment } from '../../../environments/environment';

/** The login query's admin user: the profile plus the user's GLOBAL preferences (NBO-2516). */
export type AdminUserWithPreferences = AdminUser & { preferences?: AdminUserPreferenceResponse | null };

@Injectable({
  providedIn: 'root'
})
export class AdminUserService {
  constructor(private apollo: Apollo) {}

  getTenants(user: any) {
    if (user && user.email) {
      const query = this.apollo.watchQuery<{ adminUser: AdminUserWithPreferences }>({
        query: AdminUserTenants,
        variables: { email: user.email },
        fetchPolicy: 'no-cache',
        context: {
          skipAuth: true, // Skip the auth context
          headers: {
            tenant: user.tenantId || '',
            apikey: environment.propeller.api.key
          }
        }
      });

      return query;
    }
    return null;
  }
}
